var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import dayjs from 'dayjs';
//dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
import { Button } from '@swiggy-private/dls-web-core/dist/components/Button';
import { TextButton } from '@swiggy-private/dls-web-core/dist/components/TextButton';
import style from './GenerateReportButton.module.scss';
import DatePicker from '@/components/DatePicker';
//includes
import { getReportApi } from '@/includes/api/report';
//stores
import useAccountStore from '@/stores/account';
import { IconFileDownload } from '@/constants/icons/svg';
import { tokens } from '@swiggy-private/dls-web-common/dist/components/tokens';
import { AdvertiserDimensions } from '@local/typedefs/dist/protos/campaign/AdvertiserMetrics';
function downloadFile(urlData) {
    const anchorEl = document.createElement('a');
    anchorEl.href = urlData;
    anchorEl.setAttribute('download', 'report.csv');
    anchorEl.click();
}
export const matchDisabledDays = (dateToCheck, referenceDate) => {
    if (!referenceDate) {
        return (dayjs(dateToCheck).isBefore(dayjs().subtract(6, 'months')) ||
            dayjs(dateToCheck).isAfter(dayjs().subtract(1, 'day')));
    }
    return (dayjs(dateToCheck).isBefore(dayjs(referenceDate)) ||
        dayjs(dateToCheck).isAfter(dayjs().subtract(1, 'day')));
};
const ModalContent = ({ closeModal, campaignIds, campaignName }) => {
    const { getCurrentAccountId } = useAccountStore();
    const [startDate, setStartDate] = React.useState();
    const [endDate, setEndDate] = React.useState();
    const [reportReady, setReportReady] = React.useState(undefined);
    const [isError, setIsError] = React.useState(false);
    const [reportUrl, setReportUrl] = React.useState();
    const generateReport = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!startDate || !endDate)
            return;
        const accountId = yield getCurrentAccountId();
        const dimensions = (campaignIds === null || campaignIds === void 0 ? void 0 : campaignIds.length)
            ? [
                AdvertiserDimensions.DIMENSION_CAMPAIGN,
                AdvertiserDimensions.DIMENSION_KEYWORD,
                AdvertiserDimensions.DIMENSION_AD_CANDIDATE,
                AdvertiserDimensions.DIMENSION_DAY,
            ]
            : [
                AdvertiserDimensions.DIMENSION_CAMPAIGN,
                AdvertiserDimensions.DIMENSION_KEYWORD,
                AdvertiserDimensions.DIMENSION_AD_CANDIDATE,
                AdvertiserDimensions.DIMENSION_AD_LINKED_CATALOG_ID,
            ];
        const result = yield getReportApi({
            campaignIds,
            startTime: startDate,
            endTime: endDate,
            accountId,
            dimensions,
        });
        if (result === null || result === void 0 ? void 0 : result.data.done) {
            setReportReady(true);
            setReportUrl(result.data.file);
            setIsError(false);
        }
        else if ((result === null || result === void 0 ? void 0 : result.data.done) === false) {
            setReportReady(false);
            setReportUrl(undefined);
            setIsError(false);
        }
        else {
            setReportReady(undefined);
            setReportUrl(undefined);
            setIsError(true);
        }
    });
    const getDescription = () => {
        if (reportReady) {
            return `Your performance report is ready. You can download the report.`;
        }
        return `Generate a report for your ${campaignName ? `campaign ${campaignName}` : `campaigns`}. Choose the date range you want to get the results for.`;
    };
    const handleDownload = () => {
        reportUrl && downloadFile(reportUrl);
    };
    const getFileName = () => {
        if (!reportUrl || !startDate || !endDate)
            return '';
        return `${dayjs(startDate).format('DD_MM_YYYY')}-${dayjs(endDate).format('DD_MM_YYYY')}.csv`;
    };
    const renderReportStatus = () => {
        if (isError) {
            return (React.createElement("div", { className: style.downloadContainer },
                React.createElement(Text, { variant: DlsFontVariants.button_Text_BT3, color: DlsColorTokens.primary }, "Something went wrong.")));
        }
        return reportReady ? (React.createElement("div", { className: style.downloadContainer },
            React.createElement("div", { className: style.fileLabels },
                React.createElement(Text, { variant: DlsFontVariants.body_B1_Bold, color: DlsColorTokens.text_Highest_Emphasis, className: style.fileName }, getFileName())),
            React.createElement("div", { className: style.downloadButton },
                React.createElement("button", { className: style.button, onClick: handleDownload },
                    React.createElement(IconFileDownload, { fillColor: tokens.colors.orange1 }),
                    React.createElement(Text, { variant: DlsFontVariants.button_Text_BT3, color: DlsColorTokens.primary }, "Download Report"))))) : (reportReady === false && (React.createElement("div", { className: style.downloadContainer },
            React.createElement(Text, { variant: DlsFontVariants.button_Text_BT3, color: DlsColorTokens.primary }, "Report generation is in progress. Please retry later."))));
    };
    return (React.createElement("div", { className: style.container },
        React.createElement(Text, { variant: DlsFontVariants.header_H2_Black, color: DlsColorTokens.text_Highest_Emphasis, className: style.modalTitle }, reportReady
            ? `Your report is ready`
            : `Generate Performance Report`),
        React.createElement(Text, { variant: DlsFontVariants.body_B1_Reg, color: DlsColorTokens.text_Med_Emphasis, className: style.modalText }, getDescription()),
        React.createElement("div", { className: style.reportStatus }, renderReportStatus()),
        React.createElement("div", { className: style.dateRangeSelector },
            React.createElement(DatePicker, { value: startDate, setValue: (date) => setStartDate(date), label: "Start date", disabledDateMatcher: (date) => matchDisabledDays(date) }),
            React.createElement(DatePicker, { value: endDate, setValue: (date) => setEndDate(date), label: "End date", disabledDateMatcher: (date) => matchDisabledDays(date, startDate) })),
        React.createElement("div", { className: style.modalButtons },
            React.createElement(TextButton, { onClick: closeModal, className: style.modalCancelButton, buttonSize: "medium", color: DlsColorTokens.primary }, "Cancel"),
            React.createElement("div", { className: style.modalPrimaryButton },
                React.createElement(Button, { variant: "primary", onClick: generateReport }, "Generate Report")))));
};
export default ModalContent;
